/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2025-07-21 15:20:38
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\permission.js
 */
/*
 * @Description: mark
 * @Author: wangwangwang
 * @Date: 2020-09-04 17:18:48
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-09-05 14:32:43
 */
import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {
  getToken
} from '@/utils/auth'

NProgress.configure({
  showSpinner: false
})

const whiteList = ['/login', '/auth-redirect','/purchaseSaleStoreDetail_HX','/saleMonthReportDetail_HX','/accessoryMaterialDetail_HX','/materialSettleDetail_HX','/overdueSupplyReviewApproval']

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/login') {
      next()
      NProgress.done()
    } else {
      const hasRoles = store.getters.roles && store.getters.roles.length > 0 || true;
      if (hasRoles) {
        next()
      } else {
        next('/login')
      }
      NProgress.done()
    }
  } else {
    console.log(whiteList.indexOf(to.path))
    if (whiteList.indexOf(to.path) !== -1) {
      next()
      NProgress.done()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})